const appName = 'PhyloPsy';

// eslint-disable-next-line import/prefer-default-export
export const getFullTitle = title =>
  (title ? `${title} | ${appName}` : appName);
